import { all, put, takeLatest } from 'redux-saga/effects';
import apis from '@src/apis';
import actions from '../actions';

function* getLanguagesSaga() {
  const { status, result } = yield apis.voices.getLanguages({});
  if (!status) throw new Error();
  const languages = result.languages
    .sort((a, b) => a.rank - b.rank)
    .map((item) => ({
      value: item.code,
      label: { vi: item.vietnameseName, en: item.globalName },
      roundImage: item.roundImage,
      rank: item.rank,
    }));
  yield put(actions.language.getLanguagesSuccess(languages));
}

function* getLanguagesV3Saga() {
  const { status, result } = yield apis.language.getLanguages({});
  if (!status) throw new Error();
  const languagesV3 = result.languages.map((item) => ({
    value: item.primaryLanguageSubTag,
    label: { vi: item.name?.vi, en: item.name?.en },
    roundImage: item.roundImage,
    rank: item.rank,
  }));
  yield put(actions.language.getLanguagesV3Success(languagesV3));
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.language.actionTypes.GET_LANGUAGES, getLanguagesSaga),
    takeLatest(
      actions.language.actionTypes.GET_LANGUAGES_V3,
      getLanguagesV3Saga,
    ),
  ]);
}
